
        import '/home/builduser/work/c1dd1064fea009a6/santa-editor/packages/appManager/components/EmptyState/EmptyState.scss.css.virtualfile';
        module.exports = {"container":"_container_1qeuy_1","text":"_text_1qeuy_4","paragraph":"_paragraph_1qeuy_8"};